import { memo } from '@morphic-ts/common/es6/utils';
import { circularDeepEqual } from 'fast-equals';
import { pipe } from 'fp-ts/function';
import { eqApplyConfig } from '../config';
import { EqType, EqURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const eqUnknownInterpreter = memo(() => ({
    _F: EqURI,
    unknown: cfg => env => {
        const config = eqApplyConfig(cfg);
        return pipe({ equals: circularDeepEqual }, eq => new EqType(config === undefined ? { equals: circularDeepEqual } : config(eq, env, { eq })));
    }
}));
